import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { Order } from '../public-api';

@Injectable({
  providedIn: 'root'
})
export class OrderService {
  constructor(private http: HttpClient) { }

  searchOrder(criteria: any) {
    return firstValueFrom(this.http.post<OrderSearchResult>('/api/order/search', criteria));
  }

  getCompletedPayments(criteria: any) {
    return firstValueFrom(this.http.post<OrderSearchResult>('/api/order/payments', criteria));
  }

  getOrder(id: string) {
    return firstValueFrom(this.http.get<any>(`/api/order/get/${id}`));
  }
  saveOrder(order: any) {
    return firstValueFrom(this.http.post<any>('/api/order/save', order));
  }
  deleteOrder(orderId: string) {
    return firstValueFrom(this.http.delete<any>(`/api/order/delete/${orderId}`));
  }

  getPendingOrderCount() {
    return firstValueFrom(this.http.post<number>('/api/order/pending-count', null));
  }

  getTransact(businessId: string, transactId?: string, params: any = {}) {
    return firstValueFrom(this.http.get<any>(`/api/order/transact/${businessId}/${transactId || ''}`, { params }));
  }

  getTransactOrders(businessId: string, transactId?: string, from = 0, size = 10, period: any = {}) {
    return firstValueFrom(this.http.get<OrderSearchResult>(`/api/order/transact/orders/${businessId}/${transactId || ''}`, { params: { from, size, ...period } }));
  }

  saveTransact(transact: any) {
    return firstValueFrom(this.http.post<any>('/api/order/transact/save', transact));
  }

  createTransact(businessId: string, params: any = {}) {
    return firstValueFrom(this.http.post<any>(`/api/order/transact/create/${businessId}`, null, { params }));
  }

  getTransacts(businessId: string) {
    return firstValueFrom(this.http.post<any>(`/api/order/transact/list/${businessId}`, null));
  }

  getReport(criteria: any) {
    return firstValueFrom(this.http.post<any>('/api/order/report', criteria));
  }

  setPaid(orderIds: string[], paymentData: any) {
    return firstValueFrom(this.http.post<Order[]>(`/api/order/set-paid`, { orderIds, paymentData }));
  }

  setStatus(id: string, status: string, etaMinutes?: number, reason?: string) {
    return firstValueFrom(this.http.post<any>('/api/order/set-status', { orderId: id, status, etaMinutes, reason }));
  }

}

export type OrderSearchResult = { List: any[]; Total: number; };
